// Lucide-style stroke SVGs — same geometry as admin-panel/components/icons/AdminIcons.js

const stroke = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

function SvgIcon({ children, className, size = 18, ...rest }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden
      className={className}
      {...rest}
    >
      {children}
    </svg>
  );
}

export function CalendarPlusIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M8 2v4" {...stroke} />
      <path d="M16 2v4" {...stroke} />
      <rect x="3" y="4" width="18" height="18" rx="2" {...stroke} />
      <path d="M3 10h18" {...stroke} />
      <path d="M12 14v4" {...stroke} />
      <path d="M10 16h4" {...stroke} />
    </SvgIcon>
  );
}

export function UsersIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" {...stroke} />
      <circle cx="9" cy="7" r="4" {...stroke} />
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" {...stroke} />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" {...stroke} />
    </SvgIcon>
  );
}

export function UserPlusIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" {...stroke} />
      <circle cx="9" cy="7" r="4" {...stroke} />
      <path d="M19 8v6" {...stroke} />
      <path d="M22 11h-6" {...stroke} />
    </SvgIcon>
  );
}

export function CalendarIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M8 2v4" {...stroke} />
      <path d="M16 2v4" {...stroke} />
      <rect x="3" y="4" width="18" height="18" rx="2" {...stroke} />
      <path d="M3 10h18" {...stroke} />
    </SvgIcon>
  );
}

export function ListIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M8 6h13" {...stroke} />
      <path d="M8 12h13" {...stroke} />
      <path d="M8 18h13" {...stroke} />
      <path d="M3 6h.01" {...stroke} />
      <path d="M3 12h.01" {...stroke} />
      <path d="M3 18h.01" {...stroke} />
    </SvgIcon>
  );
}

export function TagIcon(props) {
  return (
    <SvgIcon {...props}>
      <path
        d="M12.4 2.7A2 2 0 0 0 11 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 .6 1.4l8.7 8.7a2 2 0 0 0 2.8 0l5.4-5.4a2 2 0 0 0 0-2.8z"
        {...stroke}
      />
      <circle cx="7.5" cy="7.5" r="1.25" {...stroke} />
    </SvgIcon>
  );
}

export function SendIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="m22 2-7 20-4-9-9-4z" {...stroke} />
      <path d="M22 2 11 13" {...stroke} />
    </SvgIcon>
  );
}

export function ChevronLeftIcon(props) {
  return (
    <SvgIcon size={14} {...props}>
      <path d="m15 18-6-6 6-6" {...stroke} />
    </SvgIcon>
  );
}

export function ChevronRightIcon(props) {
  return (
    <SvgIcon size={14} {...props}>
      <path d="m9 18 6-6-6-6" {...stroke} />
    </SvgIcon>
  );
}
